import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 获取列表内容封装在mixins内部  getTableData方法 初始化已封装完成
import { getChannelIDTypeList, getChannelList } from '@/api/channel';
var path = process.env.VUE_APP_BASE_API;
import { getUserList, setUserAuthorities, register, deleteUser as _deleteUser } from '@/api/user';
import { getAuthorityList } from '@/api/authority';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';
import CustomPic from '@/components/customPic';
import ChooseImg from '@/components/chooseImg';
export default {
  name: 'Api',
  components: {
    CustomPic: CustomPic,
    ChooseImg: ChooseImg
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getUserList,
      path: path,
      authOptions: [],
      addUserDialog: false,
      userInfo: {
        username: '',
        password: '',
        nickName: '',
        headerImg: '',
        authorityId: '',
        authorityIds: [],
        isBindMerchant: true,
        merchantName: '',
        payInChannelId: null,
        PayInChannelItemId: '',
        PayOutChannelId: null,
        PayOutChannelItemId: ''
      },
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }, {
          min: 5,
          message: '最低5位字符',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入用户密码',
          trigger: 'blur'
        }, {
          min: 6,
          message: '最低6位字符',
          trigger: 'blur'
        }],
        nickName: [{
          required: true,
          message: '请输入用户昵称',
          trigger: 'blur'
        }],
        authorityId: [{
          required: true,
          message: '请选择用户角色',
          trigger: 'blur'
        }],
        isBindMerchant: [{
          required: true,
          message: '请选择是否为商户',
          trigger: 'blur'
        }],
        merchantName: [{
          required: true,
          message: '请输入商户名称',
          trigger: 'blur'
        }],
        payInChannelId: [{
          required: true,
          message: '请选择支付通道',
          trigger: 'blur'
        }],
        PayInChannelItemId: [{
          required: true,
          message: '请选择支付通道ID',
          trigger: 'blur'
        }],
        PayOutChannelId: [{
          required: true,
          message: '请选择提现通道',
          trigger: 'blur'
        }],
        PayOutChannelItemId: [{
          required: true,
          message: '请选择提现通道',
          trigger: 'blur'
        }]
      },
      editInChannel: '',
      editOutChannel: '',
      channelList: [],
      editInChannelIdList: [],
      editOutChannelIdList: [],
      editInChannelDisabled: true,
      editOutChannelDisabled: true
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['token'])),
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return _this.getTableData();
          case 1:
            _this.setAuthorityIds();
            _context.next = 2;
            return getAuthorityList({
              page: 1,
              pageSize: 999
            });
          case 2:
            res = _context.sent;
            _this.setOptions(res.data.list);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    setAuthorityIds: function setAuthorityIds() {
      var _this2 = this;
      this.tableData && this.tableData.forEach(function (user) {
        var authorityIds = user.authorities && user.authorities.map(function (i) {
          return i.authorityId;
        });
        _this2.$set(user, 'authorityIds', authorityIds);
      });
    },
    openHeaderChange: function openHeaderChange() {
      this.$refs.chooseImg.open();
    },
    setOptions: function setOptions(authData) {
      this.authOptions = [];
      this.setAuthorityOptions(authData, this.authOptions);
    },
    setAuthorityOptions: function setAuthorityOptions(AuthorityData, optionsData) {
      var _this3 = this;
      AuthorityData && AuthorityData.map(function (item) {
        if (item.children && item.children.length) {
          var option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName,
            children: []
          };
          _this3.setAuthorityOptions(item.children, option.children);
          optionsData.push(option);
        } else {
          var _option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName
          };
          optionsData.push(_option);
        }
      });
    },
    deleteUser: function deleteUser(row) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return _deleteUser({
                id: row.ID
              });
            case 1:
              res = _context2.sent;
              if (!(res.code === 0)) {
                _context2.next = 3;
                break;
              }
              _this4.$message.success('删除成功');
              _context2.next = 2;
              return _this4.getTableData();
            case 2:
              _this4.setAuthorityIds();
              row.visible = false;
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    enterAddUserDialog: function enterAddUserDialog() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.userInfo.authorityId = _this5.userInfo.authorityIds[0];
              _this5.$refs.userForm.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
                  var res;
                  return regeneratorRuntime.wrap(function (_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!valid) {
                          _context3.next = 3;
                          break;
                        }
                        _context3.next = 1;
                        return register(_this5.userInfo);
                      case 1:
                        res = _context3.sent;
                        if (res.code === 0) {
                          _this5.$message({
                            type: 'success',
                            message: '创建成功'
                          });
                          _this5.addUserDialog = false;
                        }
                        _this5.editOutChannelDisabled = true;
                        _this5.editInChannelDisabled = true;
                        _context3.next = 2;
                        return _this5.getTableData();
                      case 2:
                        _this5.setAuthorityIds();
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    editInChannelSelect: function editInChannelSelect() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.userInfo.payInChannelId = _this6.searchOption(_this6.channelList, _this6.editInChannel);
              _this6.editInChannelDisabled = false;
              _this6.editInChannelIdList = [];
              _context5.next = 1;
              return getChannelIDTypeList({
                ChannelId: _this6.userInfo.payInChannelId,
                Type: 0
              });
            case 1:
              res = _context5.sent;
              if (!(res.code === 0)) {
                _context5.next = 3;
                break;
              }
              if (!(res.data == null)) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              res.data.forEach(function (item) {
                _this6.editInChannelIdList.push(item.ID);
              });
              _this6.userInfo.PayInChannelItemId = _this6.editInChannelIdList[0];
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    editOutChannelSelect: function editOutChannelSelect() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.editOutChannelIdList = [];
              _this7.userInfo.PayOutChannelId = _this7.searchOption(_this7.channelList, _this7.editOutChannel);
              _this7.editOutChannelDisabled = false;
              _context6.next = 1;
              return getChannelIDTypeList({
                ChannelId: _this7.userInfo.PayOutChannelId,
                Type: 1
              });
            case 1:
              res = _context6.sent;
              if (!(res.code === 0)) {
                _context6.next = 3;
                break;
              }
              if (!(res.data == null)) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              res.data.forEach(function (item) {
                _this7.editOutChannelIdList.push(item.ID);
              });
              _this7.userInfo.PayOutChannelItemId = _this7.editOutChannelIdList[0];
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    closeAddUserDialog: function closeAddUserDialog() {
      this.$refs.userForm.resetFields();
      this.editOutChannelDisabled = true;
      this.editInChannelDisabled = true;
    },
    addUser: function addUser() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 1;
              return getChannelList();
            case 1:
              res = _context7.sent;
              if (res.code === 0) {
                _this8.channelList = res.data;
              }
              _this8.addUserDialog = true;
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    isMerchant: function isMerchant() {
      if (this.userInfo.isBindMerchant) {
        this.rules.merchantName[0].required = true;
        this.rules.payInChannelId[0].required = true;
        this.rules.PayInChannelItemId[0].required = true;
        this.rules.PayOutChannelId[0].required = true;
        this.rules.PayOutChannelItemId[0].required = true;
      } else {
        this.rules.merchantName[0].required = false;
        this.userInfo.merchantName = '';
        this.rules.payInChannelId[0].required = false;
        this.userInfo.payInChannelId = null;
        this.rules.PayInChannelItemId[0].required = false;
        this.userInfo.PayInChannelItemId = '';
        this.rules.PayOutChannelId[0].required = false;
        this.userInfo.PayOutChannelId = null;
        this.rules.PayOutChannelItemId[0].required = false;
        this.userInfo.PayOutChannelItemId = '';
      }
    },
    changeAuthority: function changeAuthority(row, flag) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!flag) {
                _context9.next = 1;
                break;
              }
              return _context9.abrupt("return");
            case 1:
              _this9.$nextTick(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var res;
                return regeneratorRuntime.wrap(function (_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      _context8.next = 1;
                      return setUserAuthorities({
                        ID: row.ID,
                        authorityIds: row.authorityIds
                      });
                    case 1:
                      res = _context8.sent;
                      if (res.code === 0) {
                        _this9.$message({
                          type: 'success',
                          message: '角色设置成功'
                        });
                      }
                    case 2:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              })));
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    }
  }
};